import { useTranslation } from 'react-i18next';

import {
  useOrganizationUsersSearchText,
  useUpdateOrganizationUsersSearchText,
} from '../../../../../../features/organization';
import { Input } from '../../../../../common';
import { RoleFilter } from './components';
import { IOrganizationUsersHeaderProps } from './types';

export const OrganizationUsersHeader = ({ expanded }: IOrganizationUsersHeaderProps) => {
  const { t } = useTranslation();
  const updateSearchText = useUpdateOrganizationUsersSearchText();
  const value = useOrganizationUsersSearchText();
  const onTextChange = (text: string) => updateSearchText(text);

  return (
    <div className="flex">
      <h3 className="typography-heading-large">{t('organization.title.users')}</h3>
      {expanded && (
        <div className="flex gap-4 ml-auto items-center">
          <Input
            type="search"
            value={value}
            onChange={onTextChange}
            className="min-w-[320px]"
            placeholder={t('organization.users.field.search.placeholder')}
          />
          <RoleFilter />
        </div>
      )}
    </div>
  );
};
